import exifr from "exifr";

// Client-side EXIF extraction for photo check-ins (spec 08 LMK-10). GPS and
// capture time are both optional — many pipelines strip EXIF entirely, so a
// null result is normal and must never block a check-in. The server does the
// authoritative distance/warn calculation from whatever coordinates arrive.

export interface ExifCapture {
  lat: number | null;
  lon: number | null;
  takenAt: Date | null;
}

export async function readExifCapture(file: File): Promise<ExifCapture> {
  const empty: ExifCapture = { lat: null, lon: null, takenAt: null };
  try {
    const [gps, tags] = await Promise.all([
      exifr.gps(file).catch(() => null),
      exifr
        .parse(file, { pick: ["DateTimeOriginal"] })
        .catch(() => null as Record<string, unknown> | null),
    ]);
    const takenAtRaw = tags?.["DateTimeOriginal"];
    const takenAt =
      takenAtRaw instanceof Date && !Number.isNaN(takenAtRaw.getTime()) ? takenAtRaw : null;
    return {
      lat: typeof gps?.latitude === "number" && Number.isFinite(gps.latitude) ? gps.latitude : null,
      lon:
        typeof gps?.longitude === "number" && Number.isFinite(gps.longitude) ? gps.longitude : null,
      takenAt,
    };
  } catch {
    return empty;
  }
}
